export const productBreakdownSelector = {
  width: "100%",
  height: "100%",
  position: "relative",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "auto 1fr auto",
  background: "white",
  zIndex: 40,
};

export const body = ({ isDesktop }) => ({
  overflow: "auto",
  display: "grid",
  gridTemplateColumns: isDesktop ? "1fr 1fr" : "1fr",
  gridTemplateRows: "1fr",
});

export const productDetailsHeader = ({
  isMobile,
  backgroundColour = "black",
}) => ({
  height: !isMobile ? "70px" : "50px",
  width: "100%",
  background: backgroundColour,
  color: "white",
  px: "20px",
});

export const detailsPanel = {
  padding: "50px",
  width: "100%",
  textAlign: "center",
  background: "white",
  zIndex: 20,
};

export const detailsSelector = () => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const changeDetailsBtn = () => ({
  borderRadius: "50%",
});

export const detailsIndicatorsContainer = () => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "20px",
});

export const detailsIndicators = () => ({
  display: "flex",
  gap: "20px",
  position: "relative",
});

export const detailsIndicator = ({ color }) => ({
  padding: "5px 20px",
  height: "100%",
  borderRadius: "10px",
  backgroundColor: color,
  cursor: "pointer",
});

export const selectedDetailIndicator = ({ color, position }) => ({
  width: "50px",
  height: "20px",
  position: "absolute",
  top: "0",
  left: "0",
  transform: `translate(${position}, -5px)`,
  border: `1px solid ${color}`,
  borderRadius: "10px",
  transition: "0.25s ease",
});

export const content = () => ({
  maxWidth: "420px",
  marginInline: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const logo = ({ widthOverride }) => ({
  padding: "50px 0",
  width: widthOverride || "70%",
});

export const detailsSubText = {
  lineHeight: "40px",
};

export const chooseButton = {
  marginTop: "50px",
  marginBottom: "10px",
};

export const extraButton = ({ isDesktop }) => ({
  marginTop: "10px",
  display: !isDesktop ? "none" : "block",
});

export const imagePanelAspectRatio = ({ isDesktop }) => ({
  width: "100%",
  position: "relative",
  height: isDesktop ? "100%" : "0",
  paddingTop: isDesktop ? "0" : `${(550 / 460) * 100}%`,

  "&:after": {
    content: "''",
    position: "absolute",
    top: !isDesktop ? "0" : "50%",
    left: !isDesktop ? "50%" : "0",
    width: "0",
    height: "0",
    transform: !isDesktop ? "translateX(-50%)" : "translateY(-50%)",
    borderTop: !isDesktop ? "20px solid white" : "20px solid transparent",
    borderBottom: !isDesktop ? "none" : "20px solid transparent",
    borderLeft: !isDesktop ? "20px solid transparent" : "20px solid white",
    borderRight: !isDesktop ? "20px solid transparent" : "none",
    zIndex: 20,
  },
});

export const imagePanel = {
  zIndex: 20,
  background: "grey",
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};

export const stageBar = {
  width: "100%",
};
